import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import "./esborrarempresa.css";

function Esborrarempresa() {
  const [empreses, setEmpreses] = useState([]);
  const [filteredEmpreses, setFilteredEmpreses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Camp de cerca
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Configuració d'ordenació
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [empresaDetalls, setEmpresaDetalls] = useState(null); // Per emmagatzemar els detalls de l'empresa
  const [showModal, setShowModal] = useState(false);


  function DashboardModal({ title, message, onConfirm, onCancel }) {
    return (
      <div className="Dashboard-modal-overlay">
        <div className="Dashboard-modal-content">
          {/* Títol del modal */}
          {title && <h3>{title}</h3>}
  
          {/* Missatge del modal */}
          <p>{message}</p>
  
          {/* Botons de confirmació i cancel·lació */}
          <div className="Dashboard-modal-buttons">
            <button
              className="dashboard-btn dashboard-btn-acceptar"
              onClick={onConfirm}
            >
              Sí
            </button>
            <button
              className="dashboard-btn dashboard-btn-cancelar"
              onClick={onCancel}
            >
              No
            </button>
          </div>
        </div>
      </div>
    );
  }
  

  const handleConfirmEsborrar = async () => {
    try {
      const response = await fetch(
        `${API_URL}/Esborrarempresa.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ idEmpresa: empresaSeleccionada.IdEmpresa }), // Passa l'ID de l'empresa
        }
      );
  
      const result = await response.json();
      if (result.success) {
        alert("Empresa esborrada correctament!");
        // Actualitza la llista d'empreses o fes alguna acció addicional
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error en la crida al servidor:", error);
      alert("Hi ha hagut un error en esborrar l'empresa.");
    } finally {
      resetView();
    }
  };


  

  useEffect(() => {
    const fetchEmpreses = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/Empreses.php`);
        const data = await response.json();
        setEmpreses(data);
        setFilteredEmpreses(data); // Inicialment totes les empreses es mostren
      } catch (error) {
        console.error("Error carregant empreses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpreses();
  }, []);

  const handleEmpresaClick = async (empresa) => {
    try {
      setEmpresaSeleccionada(empresa); // Guardem l'empresa seleccionada
  
      // Fem la crida al back-end per obtenir els detalls
      const response = await fetch(`${API_URL}/Detallsempresa.php?idEmpresa=${empresa.IdEmpresa}`);
      const data = await response.json();
  
      if (data.success) {
        setEmpresaDetalls(data.empresa); // Guardem els detalls retornats
      } else {
        console.error("Error obtenint detalls:", data.message);
      }
    } catch (error) {
      console.error("Error carregant els detalls de l'empresa:", error);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    // Filtra les empreses pel camp desitjat
    const filtered = empreses.filter(
      (empresa) =>
        empresa.Nom.toLowerCase().includes(value) ||
        empresa.NomComercial.toLowerCase().includes(value) ||
        empresa.CIF_DNI.toLowerCase().includes(value)
    );
    setFilteredEmpreses(filtered);
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });

    const sorted = [...filteredEmpreses].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredEmpreses(sorted);
  };

  const resetView = () => {
    setShowModal(false);
    setEmpresaSeleccionada(null);
    setEmpresaDetalls(null);
  };

  const handleSubmit = async () => {
      setShowModal(true);
  };

  return (
    <div>
      {showModal && (
        <DashboardModal
          title="Confirmació d'esborrat"
          message={`Vols esborrar l'empresa ${empresaDetalls.Nom}?`}
          onConfirm={handleConfirmEsborrar}
          onCancel={() => resetView()}
        />
      )}


      {!empresaSeleccionada ? (
        <>
          {/* Camp de cerca */}
          <input
            type="text"
            placeholder="Cerca per nom, CIF, etc."
            value={searchTerm}
            onChange={handleSearchChange}
            className="Dashboard-search-bar"
          />
  
          {/* Taula d'empreses */}
          {loading ? (
            <p>Carregant empreses...</p>
          ) : filteredEmpreses.length > 0 ? (
            <table className="Dashboard-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort("Nom")}>Nom</th>
                  <th onClick={() => handleSort("NomComercial")}>Nom Comercial</th>
                  <th onClick={() => handleSort("CIF_DNI")}>CIF</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmpreses.map((empresa, index) => (
                  <tr
                    key={empresa.IdEmpresa}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                    onClick={() => handleEmpresaClick(empresa)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{empresa.Nom}</td>
                    <td>{empresa.NomComercial}</td>
                    <td>{empresa.CIF_DNI}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No s'ha trobat cap empresa.</p>
          )}
        </>
      ) : (
        <div>
          {empresaDetalls ? (
           <form className="Dashboard-form">
             
            
            <div className="Dashboard-form-row">
            <label>
                *Nom de l'empresa: 
                <input 
                  type="text"  
                  value={empresaDetalls.Nom} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Nom comercial de l'empresa: 
                <input 
                  type="text"  
                  value={empresaDetalls.NomComercial} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                *CIF: 
                <input 
                  type="text"  
                  value={empresaDetalls.CIF_DNI} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                *Tipus de via: 
                <input 
                  type="text"  
                  value={empresaDetalls.TipusVia} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                *Nom de la via: 
                <input 
                  type="text"  
                  value={empresaDetalls.NomVia} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                *Número: 
                <input 
                  type="text"  
                  value={empresaDetalls.NumVia} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Escala: 
                <input 
                  type="text"  
                  value={empresaDetalls.EscalaVia} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Pis: 
                <input 
                  type="text"  
                  value={empresaDetalls.Pis} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Porta: 
                <input 
                  type="text"  
                  value={empresaDetalls.Porta} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                *Població: 
                <input 
                  type="text"  
                  value={empresaDetalls.Poblacio} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                *Província: 
                <input 
                  type="text"  
                  value={empresaDetalls.Provincia} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                *País: 
                <input 
                  type="text"  
                  value={empresaDetalls.Pais} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                *Codi Postal: 
                <input 
                  type="text"  
                  value={empresaDetalls.CodiPostal} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Referències: 
                <textarea 
                  type="text"  
                  value={empresaDetalls.Referencies} 
                  className="readonly-textarea" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Telèfon Fixe: 
                <input 
                  type="text"  
                  value={empresaDetalls.TelefonFixe} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Mòbil 1: 
                <input 
                  type="text"  
                  value={empresaDetalls.Mobil1} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Mòbil 2: 
                <input 
                  type="text"  
                  value={empresaDetalls.Mobil2} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Whatsapp: 
                <input 
                  type="text"  
                  value={empresaDetalls.Whatsapp} 
                  className="camp-curt-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                Pàgina web: 
                <input 
                  type="text"  
                  value={empresaDetalls.Paginaweb} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                E-mail1: 
                <input 
                  type="text"  
                  value={empresaDetalls.Email1} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label>
                E-mail2: 
                <input 
                  type="text"  
                  value={empresaDetalls.Email2} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
            </div>

            <div className="Dashboard-form-row">
              <label>
                Compte Bancari: 
                <input 
                  type="text"  
                  value={empresaDetalls.CompteBancari} 
                  className="camp-llarg-input readonly-input" 
                  readOnly
                />
              </label>
              <label className="checkbox-label">
                Activa:
                <input
                type="checkbox"
                checked={empresaDetalls.Activitat === 1}
                className="readonly-checkbox"
                />
              </label>
            </div>







              
            <div className="Dashboard-button-group">
              <button type="button" className="dashboard-btn dashboard-btn-acceptar" onClick={handleSubmit}>
                Esborrar
              </button>
        
              <button type="button" className="dashboard-btn dashboard-btn-cancelar" 
                onClick={() => {
                  setEmpresaSeleccionada(null);
                  setEmpresaDetalls(null);
                }}
              >
                Cancel·lar
              </button>
            </div>

            </form>
          ) : (
            <p>Carregant detalls...</p>
          )}
        </div>
      )}

  </div>
);

  
}

export default Esborrarempresa;
